import { render, staticRenderFns } from "./BatchAdd.vue?vue&type=template&id=76969a42&"
import script from "./BatchAdd.vue?vue&type=script&lang=js&"
export * from "./BatchAdd.vue?vue&type=script&lang=js&"
import style0 from "./BatchAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports